import type { QueryClient } from '@tanstack/react-query';
import { queryKeys } from '@/shared/query';

/**
 * Refetch appointment lists/calendar/kanban and booking slot overlays.
 * Used after local mutation and after `appointment.changed` realtime signals.
 */
export function invalidateAppointments(queryClient: QueryClient): Promise<void> {
  return Promise.all([
    queryClient.invalidateQueries({ queryKey: queryKeys.appointment.all }),
    queryClient.invalidateQueries({ queryKey: ['scheduling', 'availability'] }),
    queryClient.invalidateQueries({ queryKey: ['scheduling', 'calendar-slots'] }),
  ]).then(() => undefined);
}
